import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { AssemblyArtifact } from '../models/artifact';
import { DeveloperArtifactService } from '../services/developer-artifact.service';
import { DxLookupModule } from 'devextreme-angular';
import { DxoDropDownOptionsModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

import { FieldsetSupportDirective } from "src/app/shared/fieldset-support.directive";

@Component({
    selector: 'app-developer-artifact-assembly-picker',
    templateUrl: './developer-artifact-assembly-picker.component.html',
    styleUrls: ['./developer-artifact-assembly-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxLookupModule, DxoDropDownOptionsModule, DxTemplateModule, FieldsetSupportDirective]
})

export class DeveloperArtifactAssemblyPickerComponent implements OnInit, OnChanges {

    artifactDataSource: DataSource;
    artifacts: AssemblyArtifact[] = null;
    loadingArtifactDetails = false;

    selectedArtifact: AssemblyArtifact = null;
    @Input() assemblyTypes: string[] = null;
    @Input() isReadOnly = false;
    @Input() clearSelected = false;

    private internalSelectedArtifactId: string;
    @Input() get selectedArtifactId(): string {
        return this.internalSelectedArtifactId;
    }
    set selectedArtifactId(value: string) {
        if (!value) {
            value = '';
        }
        if (this.internalSelectedArtifactId !== value) {
            this.internalSelectedArtifactId = value;
            this.selectedArtifactIdChange.emit(this.selectedArtifactId);
        }
    }
    @Output() selectedArtifactIdChange: EventEmitter<string> = new EventEmitter<string>();

    constructor(private artifactService: DeveloperArtifactService) { }

    async ngOnInit(): Promise<void> {
        this.loadingArtifactDetails = true;
        const unsortedArtifacts = await this.artifactService.getAssemblyArtifacts(true, this.assemblyTypes);
        this.artifacts = unsortedArtifacts.sort((a1, a2) => a1.Name.toLowerCase().localeCompare(a2.Name.toLowerCase()));
        this.findSelectedArtifact();
        this.loadingArtifactDetails = false;

        const store = new CustomStore({
            load: (loadOptions: any) => {
                if (loadOptions.searchValue) {
                    const search = loadOptions.searchValue.toLowerCase();
                    // For now just perform the search in-memory. Maybe later on perform an actual search on the backend, if many artifacts are present.
                    return this.artifacts?.filter(a =>
                        a.ClassName.toLowerCase().indexOf(search) >= 0 ||
                        a.AssemblyName.toLowerCase().indexOf(search) >= 0 ||
                        a.Name.toLowerCase().indexOf(search) >= 0 ||
                        a.Filename.toLowerCase().indexOf(search) >= 0 ||
                        a.Description.toLowerCase().indexOf(search) >= 0);
                }
                return this.artifacts;
            },
            byKey: (key: any) => key
        });

        this.artifactDataSource = new DataSource({
            store,
            paginate: false
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedArtifactId) {
            if (this.selectedArtifactId) {
                this.findSelectedArtifact();
            } else {
                this.clearSelectedArtifact();
            }
        } else if (this.clearSelected) {
            this.clearSelectedArtifact();
        }
    }

    findSelectedArtifact() {
        if (this.selectedArtifactId && this.artifacts) {
            this.selectedArtifact = this.artifacts.find(a => a.ArtifactId === this.selectedArtifactId);
        }
    }

    clearSelectedArtifact() {
        this.selectedArtifact = null;
        this.selectedArtifactId = '';
    }

    displayExpr(item: AssemblyArtifact) {
        return item?.Name || 'Please select...';
    }

    artifactSelectedInternal(e: any): void {
        this.selectedArtifact = e.value as AssemblyArtifact;
        this.selectedArtifactId = this.selectedArtifact?.ArtifactId;
    }
}
